import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
// import interactionPlugin from "@fullcalendar/interaction";
import allLocales from "@fullcalendar/core/locales-all";
// import timeGridPlugin from "@fullcalendar/timegrid";
import "./FullCalendario.scss";

/*DOCUMENTAÇÃO
    https://fullcalendar.io/docs/react
*/

export default function FullCalendario({
  className = "",
  theme = "1",
  events = [
    {
      title: "ID: 1",
      start: "2025-08-01T11:30:00",
      className: "processando",
      extendedProps: {
        descricao: "Aguardando aprovação",
      },
    },
    {
      title: "ID: 1",
      start: "2025-08-01T13:30:00",
      className: "pendente",
      extendedProps: {
        descricao: "Aguardando aprovação",
      },
    },
  ],
  handleEventClick = (info) => {
    alert(
      `Evento: ${
        info.event.title
      }\nData: ${info.event.start.toLocaleDateString()}`,
    );
  },
}) {
  return (
    <div className={`fullcaledanrio ${className} theme${theme} mb-3`}>
      <FullCalendar
        plugins={[dayGridPlugin]}
        eventClick={handleEventClick}
        locales={allLocales}
        locale="pt-br"
        contentHeight="auto"
        eventTimeFormat={{
          hour: "2-digit",
          minute: "2-digit",
          omitZeroMinute: false,
          meridiem: false,
        }}
        // headerToolbar={{
        //   start: "prev,next today",
        //   center: "title",
        //   end: "dayGridDay dayGridWeek dayGridMonth",
        // }}
        eventDidMount={(info) => {
          info.el.setAttribute("data-tooltip-id", "tooltip-001");
          info.el.setAttribute(
            "data-tooltip-content",
            info.event.extendedProps.descricao || "",
          );
        }}
        events={events}
      />
    </div>
  );
}
